<template>
  <div class="yh-page">
    <el-card class="pt-3" v-loading="loading || saving" :element-loading-text="loadingText">
      <span v-show="activeName == 'attach'" style="position: absolute; right: 50px; top: 40px; z-index: 999;">
        <span @click="view_mode='list'" class="mr-1" style="cursor: pointer;"
              :class="view_mode === 'list' ? 'text-primary' : ''">
          <svg-icon icon-class="block-list"></svg-icon>
        </span>
        <span @click="view_mode='card'" style="cursor: pointer;"
              :class="view_mode === 'card' ? 'text-primary' : ''">
          <svg-icon icon-class="block-card"></svg-icon>
        </span>
        <span class="mx-2">|</span>
        <el-tooltip class="item" effect="light" content="上传" placement="top-start">
          <el-button type="text" @click="handleUpload"><i class="el-icon-upload"></i></el-button>
        </el-tooltip>
        <!--el-button type="primary" size="mini" icon="el-icon-plus" @click="handleUpload">上传</el-button-->
      </span>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="tabLabel.basic" name="basic" class="px-4 py-3">
          <el-form :rules="rules" ref="dataForm" :model="fd" label-position="right" label-width="120px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="船名" prop="name">
                  <el-input v-model="fd.name" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="曾用名" prop="former_name">
                  <el-input v-model="fd.former_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船舶识别号" prop="id_code">
                  <el-input v-model="fd.id_code" :disabled="!is_superuser"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船检登记号" prop="inspection_reg_num">
                  <el-input v-model="fd.inspection_reg_num"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="航区" prop="airworthiness_area">
                  <el-select class="filter-item" v-model="fd.airworthiness_area" filterable
                            placeholder="请选择适合区域" style="width: 100%;">
                    <el-option v-for="(area, index) in airworthiness_area_list" :key="index" :label="area.value"
                              :value="area.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船籍港" prop="reg_port">
                  <el-input v-model="fd.reg_port"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="总吨位" prop="gross_tonnage">
                  <el-input type="Number" v-model="fd.gross_tonnage" :disabled="!is_superuser"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="净吨位" prop="net_tonnage">
                  <el-input type="Number" v-model="fd.net_tonnage"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="border-top py-3"><h5 class="text-center">船舶主要项目</h5></el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="船舶类型" prop="type">
                  <el-select class="w-100" v-model="fd.type" filterable placeholder="请选择船舶类型">
                    <el-option v-for="(type, index) in type_list" :key="index" :label="type.value" :value="type.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="建造完工日期" prop="construct_date">
                  <el-date-picker v-model="fd.construct_date"
                                  type="date" value-format="yyyy-MM-dd"
                                  placeholder="请选择建造完工日期" class="w-100"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="改建日期" prop="reconstruct_date">
                  <el-date-picker v-model="fd.reconstruct_date"
                                  type="date" value-format="yyyy-MM-dd"
                                  placeholder="请选择改建日期" class="w-100"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--船龄-->
                <el-form-item label="船龄" prop="age">
                  <el-input class="w-100" v-model="ship_age" readonly></el-input>
                  <!--span>{{ ship_age }}</span-->
                </el-form-item>
              </el-col>
            </el-row>
            <!--<el-row>
              <el-col :span="24">
                <el-form-item label="船舶建造地点" prop="construct_place">
                  <el-input v-model="fd.construct_place"></el-input>
                </el-form-item>
              </el-col>
            </el-row>-->
            <el-row>
              <el-col :span="12">
                <el-form-item label="船舶制造厂" prop="construct_plant">
                  <el-input v-model="fd.construct_plant"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="船舶改建厂" prop="reconstruct_plant">
                  <el-input v-model="fd.reconstruct_plant"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="船舶所有人" prop="owner">
                  <el-select class="w-100" v-model="fd.owner" filterable multiple
                            placeholder="请选择船舶所有人">
                    <el-option v-for="customer in customer_list" :key="customer.id" :label="customer.name"
                              :value="customer.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
          <el-col :span="24" class="text-center py-2"><h5>船体部分</h5></el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="总长" prop="total_length">
                  <el-input type="Number" v-model="fd.total_length"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船宽" prop="total_width">
                  <el-input type="Number" v-model="fd.total_width"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="型深" prop="depth">
                  <el-input type="Number" v-model="fd.depth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="空载排水量" prop="light_displacement">
                  <el-input type="Number" v-model="fd.light_displacement"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="船体材料" prop="hull_material">
                  <!--el-input v-model="fd.hull_material"></el-input -->
                  <el-select v-model="fd.hull_material" class="w-100">
                    <el-option v-for="item in hull_material_list" :key="item.code" :label="item.value"
                              :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="载重吨位" prop="load_tonnage">
                  <el-input type="Number" v-model="fd.load_tonnage"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最低配员人数" prop="crew_num">
                  <el-input type="Number" v-model="fd.crew_num"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="text-center py-2"><h5>轮机部分</h5></el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="主机型号" prop="host_model">
                  <el-input v-model="fd.host_model"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="主机类型" prop="host_type">
                  <el-input v-model="fd.host_type"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="主机台数" prop="host_number">
                  <el-input type="Number" v-model="fd.host_number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船舶功率" prop="power">
                  <el-input type="Number" v-model="fd.power"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="text-center py-2"><h5>其他</h5></el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="是否港澳航线" prop="hk_route">
                  <el-switch v-model="fd.hk_route"
                            active-text="是"
                            inactive-text="否"
                            :active-value="1"
                            :inactive-value="0">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="航行范围" prop="sailing_range">
                  <el-input v-model="fd.sailing_range"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="经营方式" prop="operation_mode">
                  <el-select class="w-100" v-model="fd.operation_mode" filterable placeholder="请选择船舶类型">
                    <el-option v-for="(item, index) in operation_mode_list" :key="index" :label="item.value"
                              :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="船舶MMSI" prop="mmsi">
                  <el-input v-model="fd.mmsi"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船级" prop="classification">
                  <el-input v-model="fd.classification"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船旗" prop="flag">
                  <el-input v-model="fd.flag"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原船籍港" prop="origin_reg_port">
                  <el-input v-model="fd.origin_reg_port"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="是否会员船舶" prop="is_member">
                  <el-input v-model="is_member" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="船舶归属人" prop="member_name" v-if="is_member ==='是'">
                  <el-input v-model="member_name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item  prop="origin_reg_port" >
                  <el-button type="warning" size="small" @click="ShowMemberInfo" v-if="is_member ==='是'">查看会员信息</el-button>
                  <el-button type="warning" size="small" @click="handleAccountDetail" v-if="is_member ==='是'">查看风险准备金流水</el-button>
                  <el-button type="warning" size="small" @click="ShowActivity" v-if="is_member ==='是'">查看参加活动记录</el-button>
                  <el-button type="warning" size="small" @click="ShowPolicy" v-if="is_member ==='是'">查看保单记录</el-button>
                </el-form-item>


              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="tabLabel.attach" name="attach">
          <el-row v-show="view_mode==='card'">
            <el-card :body-style="{padding: '0px'}" style="float: left; margin: 20px; cursor: pointer;"
                     v-for="item in fileList" shadow="hover" v-preview="item.url" :alt="item.name"
                     preview-title-enable="true" preview-nav-enable="true" :key="item.id" v-show="!isPdfFile(item.name)">
              <div style="width: 160px; height: 160px">
                <div :style="get_style(item.url)"></div>
              </div>
              <div style="width: 160px; height: 48px; padding: 6px">
                <span style="font-size: 4px;">{{ item.name }}</span>
              </div>
            </el-card>
            <el-card :body-style="{padding: '0px'}" style="float: left; margin: 20px; cursor: pointer;"
                     v-for="item in fileList" shadow="hover" :key="item.id+300" v-show="isPdfFile(item.name)">
              <div style="width: 160px; height: 160px" @click="previewPdf(item)">
                <div :style="get_style(item.url)"></div>
              </div>
              <div style="width: 160px; height: 48px; padding: 6px">
                <span style="font-size: 4px;">{{ item.name }}</span>
              </div>
            </el-card>
          </el-row>
          <el-table v-show="view_mode==='list'" :key="0" :data="fileList" stripe v-loading="loading"
                    element-loading-text="正在加载数据，请稍等..."
                    fit highlight-current-row
                    class="w-100 mt-2">
            <!-- 文件名称 -->
            <el-table-column align="left" label="文件名">
              <template slot-scope="scope">
                <template v-if="shipid != undefined && $perm(['ship.view_ship'])">
									<span class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                        preview-title-enable="true"
                        preview-nav-enable="true"
                        v-show="!isPdfFile(scope.row.name)">{{scope.row.name}}</span>
                  <span class="text-link" @click="previewPdf(scope.row)"
                        v-show="isPdfFile(scope.row.name)" >{{scope.row.name}}</span>
                  <span class="ml-1">
                    <el-tooltip class="item" effect="light" content="重命名" placement="top-start">
                      <el-button v-show="!scope.row.display_rename" size="mini" type="text"
                                 @click="handleOpenRename(scope.row)"><i class="el-icon-edit"></i></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="确定" placement="top-start">
                      <el-button v-show="scope.row.display_rename" size="mini" type="text"
                                 @click="handle_rename(scope.row)"><i class="el-icon-check"></i></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="取消" placement="top-start">
                      <el-button v-show="scope.row.display_rename" size="mini" type="text"
                                 @click="$set(scope.row, 'display_rename', false)"><i class="el-icon-close"></i></el-button>
                    </el-tooltip>
									</span>
                  <file-rename :ref="'rename' + scope.row.id" object-type="ship.ship" :file-type-list="file_type_list"
                               :object-name="fd.name" :cert-file="scope.row"
                               :visible="scope.row.display_rename===true"></file-rename>
                </template>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <!-- 文件原名 -->
            <el-table-column align="left" label="文件原名">
              <template slot-scope="scope">
                <span>{{scope.row.original_name}}</span>
              </template>
            </el-table-column>
            <!-- 文件大小 -->
            <el-table-column min-width="20%" align="left" label="文件大小">
              <template slot-scope="scope">
                <span>{{scope.row.size | formatSize }}</span>
              </template>
            </el-table-column>
            <!-- 按钮组 -->
            <el-table-column align="left" label="操作" min-width="16%"
                             class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                  <el-button v-if="$perm(['ship.change_ship', 'ship.add_ship'])"
                             type="text" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="下载" placement="top-start">
                  <el-button v-if="shipid != undefined"
                             type="text" @click="handleDownload(scope.row)"><i class="el-icon-download"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="证书数据" placement="top-start">
                  <el-button v-if="false"
                             type="text" @click="handleCertInfo(scope.row)"><i class="el-icon-folder-opened"></i></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="tabLabel.history" name="history">
          <el-table :data="ship_history" style="width: 100%">
            <el-table-column
              prop="ship_number"
              label="船舶识别号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="ship_name"
              label="船舶曾用名"
              width="180">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="tabLabel.penalty" name="penalty">
          <el-table :data="ship_penalty" style="width: 100%">
            <el-table-column
              prop="处罚事由"
              label="处罚事由"
              width="500">
            </el-table-column>
            <el-table-column
              prop="处罚日期"
              label="处罚日期"
              width="150">
            </el-table-column>
            <el-table-column
              prop="处罚机关"
              label="处罚机关"
              width="250">
            </el-table-column>
            <el-table-column
              prop="被处罚人名称"
              label="被处罚人名称"
              width="150">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="tabLabel.service" name="service">
          <el-table :key="0" :data="service_list" stripe fit class="w-100">
                <!-- 服务记录 -->
                <el-table-column align="left" label="船员名" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.crew_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="职位" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.position}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="开始时间" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.start_date}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="结束时间" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.end_date}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="上船地点" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.start_place}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="离船地点" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.end_place}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="薪资" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.wage}}</span>
                  </template>
                </el-table-column>
     
                <!-- 按钮组 -->
                <el-table-column align="left" label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                      <el-button
                                type="text" @click="handleEditService(scope.row)"><i class="el-icon-edit"></i></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                      <el-button
                                type="text" @click="handleDeleteService(scope.row)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
        </el-tab-pane>
      </el-tabs>
      <div :class="activeName === 'basic' ? 'border-top' : ''" class="pt-3" style="padding-left: calc(1.5rem + 120px);">
        <el-button size="small" @click="cancelData">取消</el-button>
        <el-button v-if="$perm(['ship.change_ship'])" size="small" type="primary" @click="updateData">保存</el-button>
        <el-button type="primary" size="small"  @click="handleAddService">新增船员服务记录</el-button>
        <el-button v-if="$perm(['ship.change_ship'])" size="small" type="primary" @click="updateRealData">同步海事局数据</el-button>
        <el-button v-if="$perm(['ship.change_ship'])" size="small" type="primary" @click="updatePyzData">配员证截图刷新</el-button>
        <el-button v-if="$perm(['ship.change_ship'])" size="small" type="primary" @click="updateDyqzData">抵押权登记证截图刷新</el-button>
        <el-button v-if="fd.update_status === '0' && $perm(['ship.examine_change_ship'])" size="small" @click="openShipChangeVisible">审核船舶修改</el-button>
      </div>
    </el-card>
    <el-dialog :visible.sync="InfolistVisible" width="60%">
        <el-table :data="accountDetailList" border show-summary style="width: 70%">
          <el-table-column prop="create_time" label="日期" width="180">
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="180">
          </el-table-column>
          <el-table-column prop="operation_type" label="类型" width="180">
          </el-table-column>
          <el-table-column prop="creator_name" label="创建人">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="InfolistVisible = false">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog :visible.sync="activityVisible" width="65%">
        <el-table :data="activityList" border style="width: 70%">
          <el-table-column prop="activity_name" label="活动名" width="180">
          </el-table-column>
          <el-table-column prop="type" label="类型" width="180">
          </el-table-column>
          <el-table-column prop="create_time" label="参与时间" width="180">
          </el-table-column>
          <el-table-column prop="begin_date" label="活动开始时间" width="180">
          </el-table-column>
          <el-table-column prop="end_date" label="活动结束时间" width="180">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="activityVisible = false">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog :visible.sync="policyVisible" width="65%">
        <el-table :data="policyList" border style="width: 70%">
          <el-table-column prop="policy_number" label="保单号" width="180">
          </el-table-column>
          <el-table-column prop="insurance_company_branch_office" label="保险公司" width="180">
          </el-table-column>
          <el-table-column prop="insured" label="被保险人" width="180">
          </el-table-column>
          <el-table-column prop="insurance_type" label="险种" width="180">
          </el-table-column>
          <el-table-column prop="effective_date" label="起保日期" width="180">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="policyVisible = false">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog :visible.sync="shipChangeVisible" width="65%">
        <el-table :data="changList" border style="width: 70%">
          <el-table-column prop="change" label="修改信息" width="420">
          </el-table-column>
          <el-table-column prop="info" label="修改内容" width="420">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="retreatedShipUpdate">回退到上一版本</el-button>
          <el-button type="primary" @click="examineShipUpdate">确认本次修改</el-button>
          <!-- <el-button type="primary" @click="policyVisible = false">取消</el-button> -->
        </span>
    </el-dialog>

    <upload-dialog ref="upload" :object-name="fd.name"
                   :file-type-list="file_type_list"
                   object-type="ship.ship"
                   :object-id="shipid"
                   :is-upload="shipid != undefined"
                   :default-issue-date.sync="default_issue_date"
                   :default-expire-date.sync="default_expire_date"
                   @uploaded="loadFileList('ship.ship', shipid)"
                   @appended="handleAppended">
    </upload-dialog>

    <common-form ref="cert_info"></common-form>

    <el-dialog :visible.sync="serviceVisible" width="50%">
            <el-form label-width="120px">
            <el-form-item label="选择船员" v-if="service_opear_type !== 'update'">
                <el-select v-model="service_form.crew_id" placeholder="请选择船员"
                  filterable value-key="id"
                  remote :remote-method="remoteCrewMethod" :loading="service_loading"
                >
                  <el-option v-for="s in services" :key="s.id"
                      :label="s.name" :value="s.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
                <el-date-picker type="date" placeholder="选择日期" v-model="service_form.start_date"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
                <el-date-picker type="date" placeholder="选择日期" v-model="service_form.end_date"></el-date-picker>
              </el-form-item>
            <el-form-item label="上船地点" width="50%">
                <el-input maxlength="64" v-model="service_form.start_place"></el-input>
            </el-form-item>
            <el-form-item label="离船地点" width="50%">
                <el-input maxlength="64" v-model="service_form.end_place"></el-input>
            </el-form-item>
            <el-form-item label="职位" width="50%">
                <el-input maxlength="64" v-model="service_form.position"></el-input>
            </el-form-item>
            <el-form-item label="薪资" width="50%">
                <el-input type="number" v-model="service_form.wage"></el-input>
            </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addService" v-if="service_opear_type === 'create'">确 定</el-button>
                <el-button type="primary" @click="updateService" v-if="service_opear_type === 'update'">确 定</el-button>
            </span>

        </el-dialog>

    <el-dialog :title="pdfname" :visible.sync="previewVisible">
      <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
    </el-dialog>
  </div>
</template>
<script>
  import ship from '@/mixins/ship'
  import {getCrewList,getCrewServiceList,CreateCrewService,deleteCrewService,UpdateCrewService,getServiceInfo} from '@/api/crew'
  import loading from '@/mixins/loading'
  import {fetchShip, updateShip,getShipActivity,getShipPolicy,getMemberInfo, getShipInfo,retreatedShip,examineShip,searchShipDiff,getShipRealData,updataWebpage} from "@/api/ship";
  import {fetchFileList} from "@/utils";
  import {formatSize} from "@/utils/misc";
  import UploadDialog from "@/components/UploadDialog";
  import FileRename from "@/components/FileRename";
  import CommonForm from "@/components/CommonForm/CertDataProcessor.vue";
  import {downloadFile, removeFile, rename} from "@/api/upload";
  import {
    fetchInsuranceObjectFileList
  } from "@/api/common";
  import {
    shipAccountDetail
  } from '@/api/member'
  import VuePdfPreview from "@/components/VuePdfPreview"

  export default {
    name: "create",
    mixins: [ship, loading],
    filters: {
      formatSize
    },
    components: {
      UploadDialog,
      FileRename,
      VuePdfPreview,
      CommonForm
    },
    data() {
      return {
        activeName: 'basic',
        tabLabel: {
          basic: "基本信息",
          attach: "附件",
          history: "船舶历史",
          penalty: "行政处罚",
          service: "船员服务记录",
          account: "风险准备金"
        },
        is_superuser: false,
        service_form:{},
        ship_age: null,
        view_mode: 'list',
        InfolistVisible:false,
        activityVisible:false,
        serviceVisible:false,
        service_opear_type:'',
        command:'',
        service_loading:false,
        webpage_loading:false,
        policyVisible:false,
        fileList: [],
        activityList:[],
        services:[],
        policyList:[],
        service_list:[],
        accountDetailList:[],
        default_issue_date: '',
        is_member:'否',
        member_id:null,
        member_name:null,
        default_expire_date: '',
        rename_data: {},
        previewVisible: false,
        shipChangeVisible:false,
        changList:[],
        pdfname: '',
        pdfUrl: '',
        ship_history: [],
        ship_penalty: []
        // test_jpg_url: 'https://n.sinaimg.cn/photo/700/w1000h500/20210603/57a6-kracxep9657657.png',
      }
    },
    methods: {
      updatePyzData(){
        this.loading = true
        updataWebpage({id:this.shipid,'command':'配员证'}).then(res => {
                this.loading = false
                this.$message({type: 'success', message: '更新成功!'})
                this.loadFileList("ship.ship", this.shipid);
            }).catch(err => {
                this.$message.error(err)
            })
      },
      updateDyqzData(){
        this.loading = true
        updataWebpage({id:this.shipid,'command':'抵押权'}).then(res => {
                this.loading = false
                this.$message({type: 'success', message: '更新成功!'})
                this.loadFileList("ship.ship", this.shipid);
            }).catch(err => {
                this.$message.error(err)
            })
      },
      addService(){
            if (!this.service_form.crew_id){
              this.$error_message("请选择船员！")
              return
            }
            if (!this.service_form.start_date){
              this.$error_message("请选择开始时间！")
              return
            }
            this.service_form.ship_id = this.shipid
            CreateCrewService(this.service_form).then(res => {
                this.$message({type: 'success', message: '创建成功!'})
                this.serviceVisible = false
                this.getServiceList()
            }).catch(err => {
                this.$message.error(err)
            })
        },
        handleOpenRename(row) {
          this.$refs['rename' + row.id].initialize()
          this.$set(row, 'display_rename', true)
        },
      updateService(row){
            if (!this.service_form.start_date){
                  this.$error_message("请选择开始时间！")
                  return
                }
            UpdateCrewService(this.service_form).then(res => {
                this.$message({type: 'success', message: '更新成功!'})
                this.serviceVisible = false
                this.getServiceList()
            }).catch(err => {
                this.$message.error(err)
            })
        },
      handleEditService(row){
            this.service_opear_type = 'update'
            getServiceInfo({'id':row.id}).then(res => {
                this.service_form = res
            }).catch(err => {
                this.$message.error(err)
            })
            this.serviceVisible = true
        },
      handleDeleteService(row){        
          this.$confirm('是否删除该船员记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              deleteCrewService({id:row.id}).then(res => {
              this.$message({type: 'success', message: '删除成功!'})
              this.getServiceList()
          }).catch(err => {
                  this.$message.error(err)
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
        },
      getServiceList(){
            getCrewServiceList({'ship_id':this.shipid}).then(res => {
                this.service_list = res
            }).catch(err => {
                this.$message.error(err)
            })
        },
      handleAddService(){
            this.service_opear_type = 'create'
            this.service_form = {}
            this.serviceVisible = true
        },
      remoteCrewMethod(query) {
        if (query !== '') {
          this.service_loading = true
          setTimeout(() => {
            getCrewList({'search': query}).then(res => {
              this.services = res
              this.service_loading = false
            }).catch(err => {
              this.service_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.ships = [];
        }
      },
      updateRealData(){
        this.$confirm('同步海事局数据后,将会覆盖原系统数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        getShipRealData({ship:this.fd.name})
        .then(res => {
          this.$message.success("同步成功")
          this.handleUpdate(this.shipid)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$error_message(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        });          
      });
      },
      retreatedShipUpdate(){
        this.$confirm('确认回退后，将回退到上一个版本, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        retreatedShip({ship:this.fd.name})
        .then(res => {
          this.$message.success("回退成功")
          this.shipChangeVisible = false
          this.handleUpdate(this.shipid)
        })
        .catch(err => {
          this.$error_message(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });          
      });
      },
      examineShipUpdate(){
        examineShip({ship:this.shipid})
        .then(res => {
          this.$message.success("确认成功")
          this.shipChangeVisible = false
          this.handleUpdate(this.shipid)
        })
        .catch(err => {
          this.$error_message(err)
        })
      },
      openShipChangeVisible(){
        searchShipDiff({name:this.fd.name})
        .then(res => {
            this.changList = res
        })
        .catch(err => {
          this.$error_message(err)
        })
        this.shipChangeVisible = true
      },
      memberInfo(){
        getMemberInfo({id:this.shipid})
        .then(res => {
          this.is_member = res.is_member
          this.member_id = res.member_id
          this.member_name = res.member_name
        })
        .catch(err => {
          this.$error_message(err)
        })
      },
      ShowPolicy(){
        getShipPolicy({ ship_name:this.fd.name})
        .then(res => {
          this.policyList = res
        })
        .catch(err => {
          this.$error_message(err)
        })
          this.policyVisible = true
      },
      ShowActivity(){
        getShipActivity({ id:this.shipid })
        .then(res => {
          this.activityList = res
        })
        .catch(err => {
          this.$error_message(err)
        })
          this.activityVisible = true
      },
      handleAccountDetail() {
        shipAccountDetail({ id:this.shipid })
        .then(res => {
          this.accountDetailList = res
        })
        .catch(err => {
          this.$error_message(err)
        })
      this.InfolistVisible = true
    },
      ShowMemberInfo(){
        this.$router.push({name: 'memberUpdate', query: {id: this.member_id}})
      },
      handleUpdate(id) {
        this.loading = true
        // this.loadData()
        fetchShip(id)
          .then(res => {
            this.fd = res
            console.log(this.fd)
            // 计算船龄
            if (this.fd.construct_date) {
              let now_year = (new Date()).getFullYear(), construct_year = this.fd.construct_date.substr(0, 4);
              this.ship_age = now_year - parseInt(construct_year);
            }

            this.loadFileList("ship.ship", id);
            this.$nextTick(() => {
              this.$refs["dataForm"].clearValidate();
            });
          })
          .catch(error => {
            this.$error_message(error);
          });

        getShipInfo(id)
        .then(res => {
          if (res["code"] === 0) {
            this.ship_history = res['history']
            this.ship_penalty = res['penalty']
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
      },
      handleDelete(file) {
        /*this.file_type_list.some((item, index) => {
                      if (item.value == file.remark_name) {
                          this.cert_type_list_temp.splice(index, 0, item)
                          return true
                      }
                  }) */

        if (this.shipid != undefined) {
          removeFile(file.id)
            .then(() => {
              return fetchInsuranceObjectFileList("ship.ship", this.shipid);
            })
            .then(res => {
              this.fileList = res

              this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate()
              });
            })
            .catch(error => {
              this.$error_message(error)
            });
        } else {
          const index = this.fileList.indexOf(file)
          this.fileList.splice(index, 1)
        }
      },
      handleDownload(file) {
        downloadFile(file.id)
          .then(res => {
            let link = document.createElement("a");
            link.style.display = "none";

            let blob = new Blob([res]);
            link.href = URL.createObjectURL(blob);

            link.download = file.name;
            // link.download = res.headers['content-disposition'].match(/fushun(\S*)xls/)[0]
            document.body.appendChild(link);

            link.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(link);

            // this.downloadURL = url
            // this.filename = file.name
            // this.$refs.download.click()
            // document.body.appendChild(link)
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
      handle_rename(row) {
        // this.$refs['rename' + row.id].initialize();
        let err_message, file_type_obj;
        if (row.file_type_code === undefined) {
          this.$set(row, 'error_message', '请选择附件类型');
          return;
        }

        file_type_obj = this.file_type_list.find(type => {
          return (type.code === row.file_type_code);
        });

        if (file_type_obj.date_type && !row.file_date) {
          err_message = row.date_type === 'F' ? "发证日" : "到期日";
          this.$set(row, 'date_disapbled', false);
          this.$set(row, 'error_message', "请选择证件的" + err_message);
          return;
        }

        this.$set(row, 'error_message', undefined);
        this.rename_data.id = row.id;
        this.rename_data.object_type = "ship.ship";
        this.rename_data.file_type_code = row.file_type_code;
        this.rename_data.file_date = row.file_date;
        this.rename_data.new_name = row.new_name;
        let extension = row.extension
        rename(row.id, this.rename_data)
          .then(() => {
            return this.loadFileList('ship.ship', this.shipid);
          })
          .then(() => {
            this.fileList.forEach(item => {
              if (item.id === row.id) {
                this.$set(item, 'new_name', row.new_name);
                this.$set(item, 'extension', extension);
              }
            })
          })
          .catch(error => {
            this.$error_message(error);
          })
      },
      get_style(url) {
        if(/\S+\.(doc|docx)$/.test(url.toLowerCase())) {
          // url = require('static/filetype/word.png');
          url = 'static/filetype/word.png'
        } else if(/\S+\.(xls|xlsx)$/.test(url.toLowerCase())) {
          // url = require('static/filetype/excel.png');
          url = 'static/filetype/excel.png'
        } else if(/\S+\.(ppt|pptx)$/.test(url.toLowerCase())) {
          // url = require('static/filetype/ppt.png');
          url = 'static/filetype/ppt.png'
        } else if(/\S+\.(pdf)$/.test(url.toLowerCase())) {
          // url = require('static/filetype/pdf.png');
          url = 'static/filetype/pdf.png'
        }

        let style =  {
          width: '100%',
          height: '0',
          paddingBottom: '100%',
          overflow: 'hidden',
          backgroundPosition: 'top left',
          backgroundRepeat: 'no-repeat',
          borderBottom: '1px solid lightgray',
          backgroundImage: 'url(' + url + ')',
          webkitBackgroundSize: 'cover',
          mozBackgroundSize: 'cover',
          backgroundSize: 'cover'
        }

        return style
      },
      loadFileList(object_type, object_id) {
        return fetchFileList(object_type, object_id, this.file_type_list)
          .then(res => {
            this.fileList = res.file_list;
            this.default_issue_date = res.def_issue_date;
            this.default_expire_date = res.def_expire_date;
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
      updateData() {
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            this.saving = true
            this.loadingText = "正在更新船舶数据，请稍等..."
            const tempData = Object.assign({}, this.fd)
            updateShip(tempData.id, tempData)
              .then(res => {
                this.saving = false
                this.$message.success(res.message);
                this.$nextTick(() => {
                  this.$refs.dataForm.clearValidate()
                  this.$refs.dataForm.resetFields()
                  this.handleUpdate(tempData.id)
                  this.resetFD()
                });
              })
              .catch(error => {
                this.saving = false
                this.$error_message(error)
              });
          }
        })
      },
      handleUpload() {
        this.$refs.upload.handleOpen();
      },
      handleCertInfo(file) {
        this.$refs.cert_info.handleOpen(file);
      },
      handleAppended(fileList) {
        this.fileList = this.fileList.concat(fileList);
      },
      isPdfFile(filename) {
        var is_pdf = false;
        //获取最后一个.的位置
        var index = filename.lastIndexOf(".");
        //获取后缀
        var ext = filename.substr(index+1);
        //判断是否pdf
        if (['pdf'].indexOf(ext.toLowerCase()) !== -1) {
          is_pdf = true
        }
        return is_pdf
      },
      previewPdf(file){
        // window.open(url, 'PDF', '')
        console.log(file.url)
        this.pdfname = file.name
        this.pdfUrl = file.url
        this.previewVisible = true
      }
    },
    beforeRouteLeave (to, from, next) {
        if (to.name != 'shipList') {
          window.localStorage.removeItem('query')
        }
        next()
        },
    created() {
      this.is_superuser = this.$store.state.user.is_superuser
      var id = this.$route.query.id
      if (id === undefined) {
        this.$router.push('/404')
      } else {
        this.shipid = id
        this.loadData()
        this.handleUpdate(this.shipid)
        this.memberInfo()
        this.getServiceList()
      }
    }
  }
</script>
